import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export default function PageHeader({ title, subtitle, count, action, back }) {
    return (
        <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
            <Box sx={{ minWidth: 0 }}>
                {back}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography variant="h5" fontWeight={700} sx={{ color: '#1a2332', letterSpacing: -0.3 }}>{title}</Typography>
                    {count != null && (
                        <Chip label={count} size="small" sx={{ bgcolor: '#e8f0f5', color: '#427898', fontWeight: 700, fontSize: 12, height: 22, borderRadius: '6px' }} />
                    )}
                </Box>
                {subtitle && <Typography sx={{ color: '#64748B', fontSize: 13.5, mt: 0.5 }}>{subtitle}</Typography>}
            </Box>
            {action && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{action}</Box>}
        </Box>
    );
}
